// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jr-0";
export var animationContainer = "_jr-1";
export var itemPrice = "_jr-a";
export var itemizedContent = "_jr-9";
export var itemizedHeader = "_jr-7";
export var itemizedRow = "_jr-8";
export var itemizedSection = "_jr-6";
export var modalContent = "_jr-2";
export var orderName = "_jr-3";
export var refundOption = "_jr-4";
export var refundOptionsContainer = "_jr-5";
export var shippingLabel = "_jr-b";
export var totalRow = "_jr-c";